module.exports = __webpack_public_path__ + "static/img/ci.4914b405.svg";